import React from 'react';
import { workProcess } from '../../data/mockData';

export const HowWeWork = () => {
  return (
    <section className="py-24 bg-[rgb(17,17,19)]">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            How We Work
          </h2>
          <p className="text-xl text-[rgb(218,218,218)] max-w-3xl mx-auto">
            A structured approach that combines strategic thinking with practical execution
          </p>
        </div>

        {/* Process Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-7xl mx-auto">
          {workProcess.map((phase) => (
            <div key={phase.id} className="space-y-6">
              {/* Phase Header */}
              <div className="flex items-center space-x-4 mb-8">
                <div className="w-12 h-12 rounded-xl bg-[rgba(0,250,99,0.1)] border-2 border-[rgb(0,250,99)] flex items-center justify-center">
                  <span className="text-2xl font-bold text-[rgb(0,250,99)]">
                    {phase.id}
                  </span>
                </div>
                <h3 className="text-3xl font-bold text-white">{phase.phase}</h3>
              </div>

              {/* Steps */}
              <div className="space-y-6 pl-8 border-l-2 border-[rgba(255,255,255,0.1)]">
                {phase.steps.map((step, index) => (
                  <div
                    key={index}
                    className="relative pl-8 pb-6 last:pb-0"
                  >
                    {/* Step Indicator */}
                    <div className="absolute -left-[17px] top-0 w-8 h-8 rounded-full bg-[rgb(26,28,30)] border-2 border-[rgb(0,250,99)] flex items-center justify-center">
                      <div className="w-2 h-2 bg-[rgb(0,250,99)] rounded-full" />
                    </div>

                    {/* Step Content */}
                    <h4 className="text-xl font-semibold text-white mb-3">
                      {step.title}
                    </h4>
                    <p className="text-[rgb(161,161,170)] leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Background Image Section */}
        <div className="mt-16 rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.1)] max-w-5xl mx-auto">
          <img
            src="https://images.pexels.com/photos/9489091/pexels-photo-9489091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Team collaboration"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>
    </section>
  );
};
